// extracted by mini-css-extract-plugin
export default {"dayAvailable":"Calendar_dayAvailable__8E+A0","dayUnavailable":"Calendar_dayUnavailable__2ScR0"};